import { Divider as BaseDivider } from '@twisto/components/atoms/divider'

import * as styles from './divider.styles'

export const Divider = () => <BaseDivider css={styles.divider} />
